// extracted by mini-css-extract-plugin
export default {"flightContainer":"koranskolene-v0-flightContainer-tHPCs","flightMap":"koranskolene-v0-flightMap-vNBz5","flight":"koranskolene-v0-flight-BSISM"};